import { render, staticRenderFns } from "./edit-sisterQuestion.vue?vue&type=template&id=d20e6746&scoped=true&"
import script from "./edit-sisterQuestion.vue?vue&type=script&lang=ts&"
export * from "./edit-sisterQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./edit-sisterQuestion.vue?vue&type=style&index=0&id=d20e6746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20e6746",
  null
  
)

export default component.exports